import {PrimeIcons} from "primereact/api";
import {Button} from "primereact/button";
import {useSelector} from "react-redux";
import {useOutletContext} from "react-router-dom";

import {useSelectByCurrentLanguage} from "../../hooks/languageHooks";
import {selectForcedOpenMetaParams} from "../../redux/objectParametersSelectors";
import {useInputParameterDef, useParameterValue} from "./paramHooks";

export default function ParameterInputToggle({parameter, parameterType, label, id, parameter_details_def}) {
    const selectByCurrentLanguage = useSelectByCurrentLanguage();

    const parameterData = useInputParameterDef(parameter, parameter_details_def);
    const {displayStatus} = useOutletContext();

    const forcedOpenMetaParams = useSelector(selectForcedOpenMetaParams);

    // Wie in der Ansicht "alle": Block ist offen und lässt sich nicht zuklappen
    const isAll = displayStatus === "all" || forcedOpenMetaParams.includes(parameter);

    const {parameterValues, onValueChange} = useParameterValue(parameter, parameterType);

    const {activeParameterValue} = parameterValues;

    if (!parameterData) return null;

    /** @type {string} */
    const effectiveLabel =
        typeof label === "string" || !parameterData
            ? label
            : selectByCurrentLanguage(parameterData.nameDe, parameterData.nameEn);

    const icon = activeParameterValue ? PrimeIcons.CHEVRON_DOWN : PrimeIcons.CHEVRON_RIGHT;

    return (
        <div key={id} className={`field p-inputtext-sm text-sm flex items-center ${parameter}`} data-pr-position="top">
            <Button
                id={id}
                icon={isAll ? undefined : icon}
                label={effectiveLabel}
                disabled={isAll}
                text
                size="small"
                severity="secondary"
                className="m-0 p-1"
                onClick={isAll ? undefined : () => onValueChange({checked: !activeParameterValue}.checked || null)}
                style={{pointerEvents: isAll ? "none" : undefined, opacity: 1}}
            />
        </div>
    );
}
